import Spinner from 'app/components/Spinner'
import SimpleTable from 'app/components/table/SimpleTable'
import { PageScroll } from 'app/components/layout/PageScroll'
import { pmsReferralFilterableColumns } from './usePmsReferral'
import type { UsePmsReferralReturn } from './usePmsReferral'

export type PmsReferralComponentProps = UsePmsReferralReturn

export function PmsReferralComponent(props: PmsReferralComponentProps) {
  const { filteredRows, defaultColumns, isSaving, onSave, onSearchValueChange, onScroll } = props

  return (
    <PageScroll variant="table" contentClassName="pt-6">
      <form className="flex h-full flex-col overflow-hidden" onSubmit={onSave}>
        <SimpleTable
          className="grow"
          data={filteredRows}
          columns={defaultColumns}
          filterableColumns={pmsReferralFilterableColumns}
          hideFooter={true}
          onSearchValueChange={onSearchValueChange}
          onScroll={onScroll}
          edgePadded
        />
        <div className="flex grow-0 justify-start gap-x-4 bg-surface py-4">
          <button type="submit" className="btn btn-primary btn-sm float-right" disabled={isSaving}>
            {isSaving ? <Spinner size={5} /> : `Save`}
          </button>
        </div>
      </form>
    </PageScroll>
  )
}
